import { render, staticRenderFns } from "./ModalAlterarDevedor.vue?vue&type=template&id=37affbf2&scoped=true&"
import script from "./ModalAlterarDevedor.vue?vue&type=script&lang=js&"
export * from "./ModalAlterarDevedor.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlterarDevedor.vue?vue&type=style&index=0&id=37affbf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37affbf2",
  null
  
)

export default component.exports